<template>
  <div class="search">
    <el-form class="searchform" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">

      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">貨幣</label>
            <el-select v-model="form.currency_id" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option v-for="item in form.currency" :key="item.id" :label="item.name+' '+item.short_name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">交易類型</label>
            <el-select v-model="form.record_type" placeholder="全部">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="收入" value="0"></el-option>
              <el-option label="支出" value="1"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">賬戶代號</label>
            <el-input v-model="form.code" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
           <div class="mm-item">
            <label class="mm-label">銀行名稱</label>
            <el-input v-model="form.bankname" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">賬戶號碼</label>
            <el-input v-model="form.account_num" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">開單時間</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.starttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">交易金額</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-input type="number" placeholder="最小金額" v-model="form.startamount" style="width: 100%;" clearable></el-input>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-input type="number" placeholder="最大金額" v-model="form.endamount" style="width: 100%;" clearable></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序字段</label>
            <el-select v-model="form.sortname" placeholder="全部">
              <el-option label="記錄日期" value="addtime"></el-option>
              <el-option label="收入金額" value="income"></el-option>
              <el-option label="支出金額" value="pay"></el-option>
              <el-option label="結餘" value="surplus"></el-option>
              <el-option label="關聯交易單" value="business_id"></el-option>
              <el-option label="關聯訂單" value="order_id"></el-option>
              <el-option label="貨幣" value="currency_id"></el-option>
              <el-option label="ID" value="id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序方式</label>
            <div class="mm-row">
              <div class="flex-start">
                <el-radio v-model="form.orderby" label="DESC">由高到低</el-radio>
                <el-radio v-model="form.orderby" label="ASC">由低到高</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mm-submitbox">
        <div>
          <el-button @click="submit">清除</el-button>
        </div>
      </div>
    </el-form>
    <div @click="changesearchbox" class="rowline">
      <div>
        <i class="mm-nav-arrow el-icon-arrow-down" style="font-size: 12px; margin-right: 5px;"></i><span>{{search_hidden_text}}</span>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "Search",
  props: ['form'],
  data () {
    return {
      search_height: 0,
      search_hidden: true,
      search_hidden_text: '檢索展開',
    }
  },
  methods: {
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_hidden_text = '檢索隱藏';
        this.search_height = search_height;
        console.log();
      } else {
        this.search_hidden = true;
        this.search_hidden_text = '檢索展開'
        this.search_height = 0;
      }
    },
    submit () {
      this.form.currency_id = 2;
      this.form.record_type = '-1';
      this.form.starttime = '';
      this.form.endtime = '';
      this.form.startamount = '';
      this.form.endamount = '';
      this.form.account_num= '';
      this.form.bankname= '';
      this.form.sortname = "addtime";
      this.form.orderby = "DESC";
      // this.$emit('submit', {});
    }
  },
  mounted () {
    this.changesearchbox();
  }

}
</script>

<style scoped>
.search {
  margin-top: 20px;
}
.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.search-hidden {
  height: 0;
  overflow: hidden;
}
@media screen and (max-width: 1024px) {
  .mm-submitbox {
    display: flex;
    justify-content: flex-end;
  }
  .mm-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .mm-col {
    flex: 1 100%;
    padding: 10px 0;
  }
  .mm-label {
    flex: 0 0 80px;
    padding-left: 0;
  }
}
</style>
